import React, { useEffect, useState, useRef } from "react";

import { Field, useFormikContext } from "formik";

import { useDisclosure, Link, Box } from "@chakra-ui/react";
import { Link as ReactLink } from "react-router-dom";
import { Group } from "../../Group";
import { search } from "../../../../utils/search";
import { IncluirFiliacao } from "./IncluirFiliacao";
import { FiliacoesModal } from "./FiliacoesModal";
import { CustomButton } from "../../../../components/CustomButton";
import { FiliacaoTable } from "../../Filiacao/Table";
import { generateAddressFiliacao } from "../../../../utils/generateAddressFiliacao";
import { cpf, normalizeString } from "../../../../utils/masks";
import {
  criancaFunc,
  servicoAcolhimentoFunc,
} from "../../../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../../../Context/AuthProvider";
import { useLocation } from "react-router-dom";

export const Filiacao = ({ filiacoes, idCrianca }) => {
  const { values, setFieldValue } = useFormikContext();
  const { roleKeycloack } = useAuthProvider();
  const filiacoesRef = useRef(null);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const location = useLocation();
  const origemAcao = new URLSearchParams(location.search).get("acao");

  const [hasMae, setHasMae] = useState(false);
  const [hasPai, setHasPai] = useState(false);
  const [hasPaiDesSI, setHasPaiDesSI] = useState(false);
  const [hasMaeDesSI, setHasMaeDesSI] = useState(false);
  const [selectedFiliacao, setSelectedFiliacao] = useState("");

  const columns = [
    {
      Header: "Vínculo",
      accessor: "tipoFiliacao",
      Cell: (props) => {
        return <span>{props.value}</span>;
      },
    },
    {
      Header: "Nome",
      accessor: (row) => {
        return row;
      },
      Cell: (props) => {
        if (props?.value?.idCriancaFiliacaoAcolhido) {
          return (roleKeycloack &&
            roleKeycloack.includes(criancaFunc.visualizar)) ||
            roleKeycloack.includes(
              servicoAcolhimentoFunc.visualizarPartePPCAAM
            ) ? (
            <Link
              title={props?.value?.nome}
              as={ReactLink}
              to={"/crianca/" + props?.value.idCriancaFiliacaoAcolhido}
            >
              <span>{props?.value?.nome}</span>
            </Link>
          ) : (
            <span>{props?.value?.nome}</span>
          );
        } else {
          return <span>{props?.value?.nome}</span>;
        }
      },
    },
    {
      Header: "CPF",
      accessor: "cpf",
      Cell: (props) => {
        return <span>{props.value ? cpf(props.value) : ""}</span>;
      },
    },
    {
      Header: "Endereço",
      accessor: "logradouro",
      sortType: (rowA, rowB, id, desc) => {
        const enderecoA = generateAddressFiliacao(rowA.original);
        const enderecoB = generateAddressFiliacao(rowB.original);

        return enderecoA.localeCompare(enderecoB, "pt-BR");
      },
      Cell: (props) => {
        return <span>{generateAddressFiliacao(props.row.original)}</span>;
      },
    },
    {
      Header: "Observações",
      accessor: (row) => {
        return row;
      },
      Cell: (props) => {
        return (
          <span>
            {props?.value?.falecido === "S"
              ? "Falecido"
              : props?.value?.idCriancaFiliacaoAcolhido
              ? "Acolhido(a)"
              : ""}
          </span>
        );
      },
    },
  ];

  useEffect(() => {
    if (!!values.situacaoMae && !hasMaeDesSI) {
      setFieldValue("filiacoes", [
        ...values.filiacoes,
        {
          tipoFiliacao: "Mãe",
          nome: values.situacaoMae,
          cpf: "",
          logradouro: "",
          falecido: "",
          local: true,
          id: (values.filiacoes.length + 1) * -1,
        },
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.situacaoMae]);

  useEffect(() => {
    if (!!values.situacaoPai && !hasPaiDesSI) {
      setFieldValue("filiacoes", [
        ...values.filiacoes,
        {
          tipoFiliacao: "Pai",
          nome: values.situacaoPai,
          cpf: "",
          logradouro: "",
          falecido: "",
          local: true,
          id: (values.filiacoes.length + 1) * -1,
        },
      ]);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.situacaoPai]);

  useEffect(() => {
    const tiposFiliacao = filiacoes.map((filiacao) => filiacao.tipoFiliacao);
    setHasMae(search("Mãe", tiposFiliacao));
    setHasPai(search("Pai", tiposFiliacao));

    const paiDesSI = filiacoes.find((filiacao) => {
      return (
        filiacao.tipoFiliacao === "Pai" &&
        (filiacao.nome === "Desconhecido" ||
          normalizeString(filiacao.nome) === normalizeString("Sem informação"))
      );
    });
    const maeDesSI = filiacoes.find((filiacao) => {
      return (
        filiacao.tipoFiliacao === "Mãe" &&
        (filiacao.nome === "Desconhecida" ||
          normalizeString(filiacao.nome) === normalizeString("Sem informação"))
      );
    });

    setHasPaiDesSI(!!paiDesSI);
    setHasMaeDesSI(!!maeDesSI);
  }, [filiacoes]);

  useEffect(() => {
    if (values.filiacoes && values.filiacoes.length > 0 && !origemAcao) {
      filiacoesRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [values.filiacoes, origemAcao]);

  return (
    <Group title="Filiação">
      {filiacoes.length !== 0 && (
        <FiliacaoTable
          columns={columns}
          data={filiacoes}
          filiacoes={filiacoes}
          setFieldValue={setFieldValue}
          idCrianca={idCrianca}
        />
      )}
      {!hasMae && (
        <IncluirFiliacao
          filiacao="Mãe*"
          fieldName="situacaoMae"
          openModal={(filiacao) => {
            setSelectedFiliacao(filiacao);
            onOpen();
          }}
        />
      )}
      {!hasPai && (
        <IncluirFiliacao
          filiacao="Pai*"
          fieldName="situacaoPai"
          openModal={(filiacao) => {
            setSelectedFiliacao(filiacao);
            onOpen();
          }}
        />
      )}
      {hasPai &&
        hasMae &&
        filiacoes.length < 4 &&
        !(hasPaiDesSI && hasMaeDesSI) && (
          <CustomButton
            onClick={() => {
              setSelectedFiliacao("");
              onOpen();
            }}
            label="Incluir"
            height="30px"
            width="73px"
            mt="15px"
          />
        )}
      <Field name="filiacoes">
        {({ field, form }) => (
          <FiliacoesModal
            isOpen={isOpen}
            onOpen={onOpen}
            onClose={onClose}
            filiacao={selectedFiliacao}
            form={form}
            selected={field.value}
            props={form}
            setSelected={(value) => {
              form.setFieldValue("filiacoes", [...field.value, value]);
            }}
          />
        )}
      </Field>
      <Box ref={filiacoesRef} />
    </Group>
  );
};
